export default __webpack_public_path__ + "static/media/face_statistics_icon.03ac2538.svg";